export const AdobeAnalytics = ( errorMessages ) => {
    if( window.adobeDataLayer ){
        window.adobeDataLayer.push( {
            systemMessage: errorMessages,
            event: 'systemMessage',
        } )
    }
}